import PieChart from "components/charts/PieChart";
import { pieChartData, pieChartOptions } from "variables/charts";
import Card from "components/card";

const AnnouncementCard = () => {
  return (
    <Card extra="rounded-[20px] p-3">
      <div className="flex flex-row justify-between px-3 pt-2">
        <div>
          <h4 className="card-title">
            Announcements
          </h4>
        </div>
      </div>

      <div className="mb-auto flex h-[180px] w-full items-center justify-center">
        <h4>Nothing New</h4>
      </div>

    </Card>
  );
};

export default AnnouncementCard;
